@if(volunteerDetails(); as volunteer) {

<div class="volunteer-overview-content-dialog-part row h-100">
	<div class="col-lg-6 mb-2">
		<div class="bg-light rounded shadow-sm h-100">
			<div class="pt-2 ps-1">
				<h5>
					<span class="badge bg-secondary-subtle text-black px-3 py-2">
						Status: {{volunteer.status}}
					</span>
				</h5>
			</div>

			<div class="p-3 pt-0">
				<p>Approved to volunteer in:</p>
				<ul [class.list-unstyled]="volunteer.languages.length == 0">
					@for (lang of volunteer.languages; track lang) {
					<li>{{lang}}</li>
					} @empty {
					<p>No languages approved</p>
					}
				</ul>

				<div class="row">
					<div class="col-md-12">
						<p>Approved to volunteer as:</p>
						<ul [class.list-unstyled]="volunteer.interests.length == 0">
							@for (interest of volunteer.interests; track interest) {
							<li>{{interest}}</li>
							} @empty {
							<p>No volunteer interests</p>
							}
						</ul>

						<p>Topics:</p>
						<ul [class.list-unstyled]="volunteer.topics.length == 0">
							@for (topic of volunteer.topics; track topic) {
							<li>{{topic}}</li>
							} @empty {
							<p>No volunteer topics selected</p>
							}
						</ul>
					</div>
				</div>
			</div>
		</div>

	</div>
	<div class="col-lg-6 mb-2">
		<div class="bg-light rounded shadow-sm h-100">
			<div class="pt-2 ps-1">
				<h5>
					<span class="badge bg-secondary-subtle text-black px-3 py-2">
						Details
					</span>
				</h5>
			</div>

			<div class="p-3 pt-0">
				<table class="table table-borderless mb-4">
					<tbody>
						<tr>
							<th class="w-50">English Video:</th>
							<td>
								<div class="d-flex align-items-center">
									<span>{{volunteer.englishVideoStatus}}</span>
									@if(volunteer.hasEnVideo) {
									<div class="ms-2 play-icon" [class.color-eforall-blue]="volunteer.hasEnVideo"
										(click)="openVideoDialog(englishLanguageId)">
										<i class="fa-fw fa-circle-play fa-regular" role="button"></i>
									</div>
									}
								</div>
							</td>
						</tr>
						<tr>
							<th class="w-50">Spanish Video:</th>
							<td>
								<div class="d-flex align-items-center">
									<span>{{volunteer.spanishVideoStatus}}</span>
									@if(volunteer.hasEsVideo) {
									<div class="ms-2 play-icon" [class.color-eforall-blue]="volunteer.hasEsVideo"
										(click)="openVideoDialog(spanishLanguageId)">
										<i class="fa-fw fa-circle-play fa-regular" role="button"></i>
									</div>
									}
								</div>
							</td>
						</tr>
						<tr>
							<th class="w-50">Location:</th>
							<td>{{volunteer.placeAddress}}</td>
						</tr>
						<tr>
							<th class="w-50">Interview:</th>
							<td>{{volunteer.interviewDateUTC}}</td>
						</tr>
						<tr>
							<th class="w-50">Lead Created:</th>
							<td>{{volunteer.leadVolunteerCreatedUTC}}</td>
						</tr>
					</tbody>
				</table>

				<div>
					<h6 class="mt-2">Expertises</h6>
					<ul>
						@for (expertise of volunteer.expertises; track expertise) {
						<li>{{expertise}}</li>
						}
					</ul>
				</div>

				<div class="mb-2">
					<common-button-row [center]="true">
						<button class="btn btn-standard" (click)="showLeadDetails()">View Lead Details</button>
					</common-button-row>
				</div>
				<div>
					<h6>Weblinks:</h6>
					<ul [class.list-unstyled]="volunteer.socialLinks.length == 0">
						@for (socialLink of volunteer.socialLinks; track $index) {
						<li><a href="{{socialLink.url}}" target="_blank">{{socialLink.type}}</a></li>
						} @empty {
						<p>No weblinks</p>
						}
					</ul>
				</div>
			</div>
		</div>
	</div>
</div>

}